import { render, staticRenderFns } from "./inventoryXADate.vue?vue&type=template&id=2c76b2f5&scoped=true"
import script from "./inventoryXADate.vue?vue&type=script&lang=js"
export * from "./inventoryXADate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c76b2f5",
  null
  
)

export default component.exports